"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _StepBarModule = _interopRequireDefault(require("./StepBar.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var StepBar = _ref => {
  var currentStepId = _ref.currentStepId,
    steps = _ref.steps,
    onChangeStep = _ref.onChangeStep,
    className = _ref.className;
  var currentStepIndex = steps.findIndex(s => s.id === currentStepId);
  var translate = 100 / steps.length * currentStepIndex;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_StepBarModule.default.StepBar, className)
  }, steps.map((s, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: s.id,
    className: _StepBarModule.default.Step,
    onClick: () => currentStepIndex > i && onChangeStep(s),
    "data-selected": currentStepIndex === i ? '' : undefined,
    "data-disabled": currentStepIndex < i ? '' : undefined
  }, s.title)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "".concat(100 / steps.length, "%"),
      left: "".concat(translate, "%")
    },
    className: _StepBarModule.default.Bar
  }));
};
exports.StepBar = StepBar;
//# sourceMappingURL=StepBar.js.map